import React, { useMemo } from 'react';
import { useTranslation } from '@shared/core';
import { ConsoleLoader } from '@apps/stays/components/ConsoleLoader/ConsoleLoader';

export const AccommodationsConsoleLoader = () => {
  const { tq } = useTranslation('accommodationsConsole');

  const messages = useMemo(() => {
    return [
      tq`Loading all hotels around your event`,
      tq`Finding the best hotels near the venue`,
      tq`Selecting hotels loved by Joy guests`,
      tq`Unlocking your exclusive Joy rates`,
      tq`Calculating walk and drive time`,
    ];
  }, [tq]);

  return (
    <ConsoleLoader
      messages={messages}
      title={tq`Finding hotels with exclusive event rates, up to 40% off.`}
    />
  );
};
